import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center pt-24">
        <div className="terminal w-96">
          <div className="terminal-header">
            <span className="terminal-dot red"></span>
            <span className="terminal-dot amber"></span>
            <span className="terminal-dot green"></span>
            <span className="ml-2">system.check()</span>
          </div>
          <div className="p-6 text-volt text-sm">
            &gt; verifying session<span className="blink"></span>
          </div>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
